import { random } from 'lodash'

const syllables = [
  'en', 'la', 'can', 'be',
  'and', 'phi', 'eth', 'ol',
  've', 'ho', 'a', 'lia',
  'an', 'ar', 'ur', 'mi',
  'in', 'ti', 'qu', 'so',
  'ed', 'ess', 'ex', 'io',
  'ce', 'ze', 'fa', 'ay',
  'wa', 'da', 'ack', 'gre'
]

export default (maxSyllableCount) => {
  let string = ''

  for (var i = 0; i < random(1, maxSyllableCount || 6); i++) {
    string += syllables[random(0, syllables.length - 1)] +

      // Sometimes add space
      (!random(0, 3) ? ' ' : '')
  }

  return string.trim()
}
